import posthog from 'posthog-js'

export const postHogIdentify = (user: any): void => {
  if (!window.posthogUserLoaded) {
    window.posthogUserLoaded = true
    posthog.identify(user?.id)
    posthog.reloadFeatureFlags()
  }
}
